import { PageAlertService } from '@abp/ng.theme.shared';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'hedou-page-alert-container',
  templateUrl: './page-alert-container.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class PageAlertContainerComponent implements OnInit {

  constructor(public service: PageAlertService) {}

  ngOnInit(): void {
  }

}
